import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
const CustomSearch2 = ({
  searchQuery,
  searchedRecord,
  getDataByPage,
  setSearchedRecord,
  setSearchQuery,
  searchData,
  pageState,
  isVideoLibraryPage,
}) => {
  return (
    <div
      className={`${
        isVideoLibraryPage
          ? "search-input-for-table-container2"
          : "search-input-for-table-container3"
      }`}
    >
      <div
        className={`${
          isVideoLibraryPage
            ? "Search-input-field-container-for-table2"
            : "Search-input-field-container-for-table3"
        }`}
      >
        <SearchIcon className="search-icon-for-table" />
        <input
          className="search-input-for-table2"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => {
            if (e.target.value == "" && searchedRecord) {
              getDataByPage(0, pageState.pageSize);
              setSearchedRecord(false);
            }
            setSearchQuery(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              searchData(searchQuery, 0, 10);
            }
          }}
        />
        {searchQuery && (
          <div className="search-bar-right-container">
            <CloseIcon
              className="mg-right-10 cp"
              onClick={() => {
                if (searchedRecord) {
                  getDataByPage();
                  setSearchedRecord(false);
                }
                setSearchQuery("");
              }}
            />
            <p
              className="cancel-Search-icon"
              onClick={() => searchData(searchQuery, 0, 10)}
            >
              Search
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomSearch2;
